/*
 * Copyright (c) 2022 biocrates life sciences ag, All rights reserved.
 */

import React from "react"

import {H3} from "@blueprintjs/core"

import env from "../../core/context/Env"
import "./InvalidLicense.scss"

export default function InvalidLicense() {
    return (
        <div>
            <div
                className="content"
                style={{
                    textAlign: "center",
                    marginTop: "40px",
                }}
            >
                <H3 className="biocrates-commons-heading">
                    No active subscription found
                </H3>
                <p style={{marginBottom: "40px"}}>
                    Please ask your organization administrator to assign you a
                    user slot or acquire a subscription in our{" "}
                    <a
                        href={`${env("SHOP_URL")}/Software/`}
                        target="_blank"
                        rel="noopener noreferrer"
                    >
                        shop
                    </a>
                    .
                </p>
                <a
                    href={env("INVALID_LICENSE_URL")}
                    className="biocrates-commons-anchor-normal"
                >
                    Visit My biocrates
                </a>
            </div>
        </div>
    )
}
